<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">
  <!--Card content-->
  <mdb-card-body class="d-sm-flex justify-content-between">
    <div style="display: contents">
      <ul class="nav nav-pills">
        <li class="nav-item">
          <a
            [ngClass]="currentSection == 'Profile' ? 'nav-link active' : 'nav-link'"
            aria-current="page"
            (click)="toggleSettingsSection('Profile')"
            >Profile</a
          >
        </li>
        <li class="nav-item">
          <a [ngClass]="currentSection == 'FIA' ? 'nav-link active' : 'nav-link'" (click)="toggleSettingsSection('FIA')"
            >FIA Documentation
          </a>
        </li>
        <!-- <li class="nav-item">
          <a [ngClass]="currentSection == 'Security' ? 'nav-link active' : 'nav-link'"
            (click)="toggleSettingsSection('Security')">Security</a>
        </li>
        <li class="nav-item">
          <a [ngClass]="currentSection == 'Activity' ? 'nav-link active' : 'nav-link'"
            (click)="toggleSettingsSection('Activity')">Activity</a>
        </li>
        <li class="nav-item">
          <a [ngClass]="currentSection == 'Privacy' ? 'nav-link active' : 'nav-link'"
            (click)="toggleSettingsSection('Privacy')">Privacy</a>
        </li>
        <li class="nav-item">
          <a [ngClass]="currentSection == 'PaymentMethods' ? 'nav-link active' : 'nav-link'"
            (click)="toggleSettingsSection('PaymentMethods')">Payment methods</a>
        </li> -->
      </ul>
    </div>
    <hr />
  </mdb-card-body>
  <!--Card content-->
  <mdb-card-body class="d-sm-flex justify-content-between" #Profile *ngIf="currentSection == 'Profile'">
    <!-- Form -->
    <form class="text-center border border-light p-5 w-100" (ngSubmit)="saveClicked()">
      <h4 class="font-weight-bold mb-4 text-left">My Profile</h4>
      <hr />
      <div *ngIf="!busy">
        <!--Error Display-->
        <div class="col">
          <div *ngIf="showError" class="alert alert-danger" role="alert">
            {{ errorMsg }}
          </div>
        </div>

        <!--Change Avatar-->
        <div class="col-6 mb-4 text-left">
          <div class="avatar text-left mb-md-0 mb-4 mx-4 d-inline-block">
            <img
              src="../../../assets/img/profilePictures/{{ settingsService.userProfile.avatarId }}.png"
              class="rounded-circle z-depth-1"
              alt="Avatar"
              style="max-width: 100px"
            />
          </div>
          <div class="mx-4 d-inline-block align-middle">
            <p class="font-weight-bold mb-1">Change Avatar</p>
            <a class="border dropdown-item text-center my-1" size="sm" (click)="avatarModal.show()" mdbWavesEffect>Edit</a>
          </div>
        </div>
        <div class="d-block col-12">
          <p class="font-weight-bold mb-1">Personal Information</p>
        </div>

        <!-- Full name -->
        <div class="md-form col-6" style="margin-top: 5px">
          <input
            [(ngModel)]="userProfile.fullName"
            mdbInput
            mdbValidate
            name="fullName"
            type="text"
            id="fullName"
            class="form-control"
            #fullName="ngModel"
            required
          />
          <label for="fullName">Full name</label>
          <mdb-error *ngIf="fullName.invalid && (fullName.dirty || fullName.touched)">First name is required</mdb-error>
          <mdb-success *ngIf="fullName.valid && (fullName.dirty || fullName.touched)"></mdb-success>
        </div>

        <!-- Display name -->
        <div class="md-form col-6" style="margin-top: 5px">
          <input
            [(ngModel)]="userProfile.displayName"
            mdbInput
            mdbValidate
            name="displayName"
            type="text"
            id="displayName"
            class="form-control"
            #displayName="ngModel"
            required
          />
          <label for="displayName">Display name</label>
          <mdb-error *ngIf="displayName.invalid && (displayName.dirty || displayName.touched)">Last name is required </mdb-error>
          <mdb-success *ngIf="displayName.valid && (displayName.dirty || displayName.touched)"></mdb-success>
        </div>

        <!-- E-mail -->
        <div class="md-form col-6" style="margin-top: 5px">
          <input
            [(ngModel)]="user.email"
            mdbInput
            mdbValidate
            name="email"
            type="text"
            id="email"
            class="form-control"
            #email="ngModel"
            required
            [pattern]="regexForEmail"
          />
          <label for="email">E-mail</label>
          <mdb-error *ngIf="email.invalid && (email.dirty || email.touched)">Email address not valid</mdb-error>
          <mdb-success *ngIf="email.valid && (email.dirty || email.touched)"></mdb-success>
        </div>

        <!-- Cellphone -->
        <div class="md-form col-6" style="margin-top: 5px">
          <input
            [(ngModel)]="user.mobile"
            mdbInput
            mdbValidate
            name="mobile"
            type="text"
            id="mobile"
            class="form-control"
            #mobile="ngModel"
            required
            [pattern]="'\\+27 [0-9]{9}$'"
            placeholder="+27 xxxxxxxxx"
          />
          <label for="mobile">Cellphone</label>
          <mdb-error *ngIf="mobile.invalid && (mobile.dirty || mobile.touched)">Cellphone number not valid</mdb-error>
          <mdb-success *ngIf="mobile.valid && (mobile.dirty || mobile.touched)"></mdb-success>
        </div>

        <!-- ID NUmber -->
        <div class="md-form col-6" style="margin-top: 5px">
          <input
            [(ngModel)]="userProfile.idNumber"
            mdbInput
            mdbValidate
            name="idNumber"
            type="text"
            id="idNumber"
            class="form-control"
            #idNumber="ngModel"
            required
            placeholder="South african ID number"
          />
          <label for="idNumber">ID Number</label>
          <mdb-error *ngIf="idNumber.invalid && (idNumber.dirty || idNumber.touched)">ID number not valid</mdb-error>
          <mdb-success *ngIf="idNumber.valid && (idNumber.dirty || idNumber.touched)"></mdb-success>
        </div>

        <div class="d-block col-12">
          <p class="font-weight-bold mb-1">Investment Information</p>
        </div>
        <!-- SDA Amount -->
        <div class="md-form col-6" style="margin-top: 5px">
          <input
            [(ngModel)]="userProfile.sdaAmount"
            mdbInput
            mdbValidate
            name="sdaAmount"
            type="number"
            id="sdaAmount"
            class="form-control"
            #sdaAmount="ngModel"
            [mdbPopover]="sdaPopTemplate"
            placement="top"
          />
          <label for="sdaAmount">SDA Amount Used</label>
          <mdb-error *ngIf="sdaAmount.invalid && (sdaAmount.dirty || sdaAmount.touched)">SDA Amount</mdb-error>
          <mdb-success *ngIf="sdaAmount.valid && (sdaAmount.dirty || sdaAmount.touched)"></mdb-success>
        </div>
        <ng-template #sdaPopTemplate
          >This is the amount of your
          <a href="https://www.resbank.co.za/en/home/what-we-do/financial-surveillance/FinSurvFAQ" target="_blank" rel="noopener noreferrer"
            >Single Discretionary Allowance (SDA)</a
          >
          that has already been used for other things.
        </ng-template>

        <!-- Fia Amount -->
        <div class="md-form col-6" style="margin-top: 5px">
          <input
            [(ngModel)]="userProfile.fiaAmount"
            mdbInput
            mdbValidate
            name="fiaAmount"
            type="number"
            id="fiaAmount"
            class="form-control"
            #fiaAmount="ngModel"
            [mdbPopover]="fiaPopTemplate"
            placement="top"
          />
          <label for="fiaAmount">FIA Amount Used</label>
          <mdb-error *ngIf="fiaAmount.invalid && (fiaAmount.dirty || fiaAmount.touched)">FIA Amount</mdb-error>
          <mdb-success *ngIf="fiaAmount.valid && (fiaAmount.dirty || fiaAmount.touched)"></mdb-success>
        </div>
        <ng-template #fiaPopTemplate
          >This is the amount of your
          <a href="https://www.resbank.co.za/en/home/what-we-do/financial-surveillance/FinSurvFAQ" target="_blank" rel="noopener noreferrer"
            >Foreign Investment Allowance (FIA)</a
          >
          that has already been used for other things.
        </ng-template>

        <div class="d-block col-12">
          <p class="font-weight-bold mb-1">Sars Details</p>
        </div>

        <!-- Income Tax ref number -->
        <div class="md-form col-6" style="margin-top: 5px">
          <input
            [(ngModel)]="userProfile.incomeTaxReferenceNumber"
            mdbInput
            mdbValidate
            name="incomeTaxReferenceNumber"
            type="text"
            id="incomeTaxReferenceNumber"
            class="form-control"
            #incomeTaxReferenceNumber="ngModel"
          />
          <label for="incomeTaxReferenceNumber">Income Tax Reference Number</label>
          <mdb-error *ngIf="incomeTaxReferenceNumber.invalid && (incomeTaxReferenceNumber.dirty || incomeTaxReferenceNumber.touched)">
            Income Tax Reference number not valid</mdb-error
          >
          <mdb-success *ngIf="incomeTaxReferenceNumber.valid && (incomeTaxReferenceNumber.dirty || incomeTaxReferenceNumber.touched)">
          </mdb-success>
        </div>

        <!-- Sars Username -->
        <div class="md-form col-6" style="margin-top: 5px">
          <input
            [(ngModel)]="userProfile.sarsUsername"
            mdbInput
            mdbValidate
            name="sarsUsername"
            type="text"
            id="sarsUsername"
            class="form-control"
            #sarsUsername="ngModel"
          />
          <label for="sarsUsername">Sars Login Username</label>
          <mdb-error *ngIf="sarsUsername.invalid && (sarsUsername.dirty || sarsUsername.touched)">Sars Login Username not valid</mdb-error>
          <mdb-success *ngIf="sarsUsername.valid && (sarsUsername.dirty || sarsUsername.touched)"></mdb-success>
        </div>

        <!-- Sars Password -->
        <div class="md-form col-6" style="margin-top: 5px">
          <input
            [(ngModel)]="userProfile.sarsPassword"
            mdbInput
            mdbValidate
            name="sarsPassword"
            type="text"
            id="sarsPassword"
            class="form-control"
            #sarsPassword="ngModel"
          />
          <label for="sarsPassword">Sars Login Password</label>
          <mdb-error *ngIf="sarsPassword.invalid && (sarsPassword.dirty || sarsPassword.touched)">Sars Login Password not valid</mdb-error>
          <mdb-success *ngIf="sarsPassword.valid && (sarsPassword.dirty || sarsPassword.touched)"></mdb-success>
        </div>
      </div>

      <!--Loading-->
      <div class="col-12 text-center">
        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <!--Save btn-->
      <div class="float-right" id="settingsSaveBtn" style="width: 100px">
        <button *ngIf="!busy" type="button" mdbBtn color="trakly-action" block="true" class="my-4" type="submit">Save</button>
      </div>
    </form>
  </mdb-card-body>

  <mdb-card-body class="d-sm-flex justify-content-between" #FIA *ngIf="currentSection == 'FIA'">
    <!-- Form -->
    <form class="text-center border border-light p-5 w-100" (ngSubmit)="GetUserMedia()">
      <h4 class="font-weight-bold mb-4 text-left">FIA Supporting Documentation</h4>
      <p class="text-left">
        This is where you can manage the shared supporting documents that are automatically included with each new FIA application
      </p>
      <hr />
      <!--Error Display-->
      <div *ngIf="!busy">
        <div class="col">
          <div *ngIf="showError" class="alert alert-danger" role="alert">
            {{ errorMsg }}
          </div>
        </div>
        <!--Main Body-->
        <div class="selection-item-full">
          <div class="dropzone" filedropzone="">
            <div class="text-wrapper">
              <i class="fas fa-upload"></i>
              <p class="hidden-sm-down">
                <a class="is-link"><strong>Browse</strong></a> to select files from your computer
              </p>
              <p class="hidden-sm-up">Click/tap to add your files or drag and drop them here</p>
            </div>
            <input class="hidden w-100 h-100" type="file" multiple="multiple" #file (change)="onFileChange($event)" name="fileUploadArea" />
          </div>
        </div>

        <div class="d-block col-12" *ngIf="userDocuments?.length > 0">
          <p class="font-weight-bold mb-1">Existing Documents</p>
        </div>
        <div class="col-12">
          <div class="table-responsive">
            <table
              mdbTable
              class="table table-responsive w-100 d-block d-md-table"
              hover="true"
              small="true"
              responsive="true"
              *ngIf="userDocuments?.length > 0"
            >
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Date Created</th>
                  <th scope="col">Type</th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr mdbTableCol *ngFor="let doc of userDocuments">
                  <th scope="row" class="align-middle">{{ doc.name }}</th>
                  <td class="align-middle">{{ doc.createdDate | date }}</td>
                  <td class="align-middle">{{ doc.fileType }}</td>
                  <td>
                    <a class="border dropdown-item text-center my-1" size="sm" (click)="DownloadFile(doc.id)" mdbWavesEffect>Download</a>
                  </td>
                  <td>
                    <a class="border dropdown-item text-center my-1" size="sm" (click)="confirmDelete(doc.id)" mdbWavesEffect>Delete</a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-12">
          <div *ngIf="!busy && userDocuments?.length == 0" class="alert alert-info text-center font-weight-bold" role="alert">
            No supporting documents uploaded
          </div>
        </div>
      </div>
      <!--Loading-->
      <div class="col-12 text-center">
        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <!--Save btn-->

      <div class="float-right" id="settingsSaveBtn">
        <button *ngIf="!busy" type="button" mdbBtn color="trakly-action" block="true" class="my-4" type="submit">Refresh</button>
      </div>
    </form>
    <!-- Form -->
  </mdb-card-body>

  <mdb-card-body class="d-sm-flex justify-content-between" #Security *ngIf="currentSection == 'Security'">
    <!-- Form -->
    <form class="text-center border border-light p-5 w-100" (ngSubmit)="saveClicked()">
      <h4 class="font-weight-bold mb-4 text-left">Security</h4>
      <hr />
      <!--Error Display-->
      <div *ngIf="!busy">
        <div class="col">
          <div *ngIf="showError" class="alert alert-danger" role="alert">
            {{ errorMsg }}
          </div>
        </div>
        ...
      </div>
      <!--Loading-->
      <div class="col-12 text-center">
        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <!--Save btn-->
      <div class="justify-content-left" id="settingsSaveBtn" style="width: 100px">
        <button *ngIf="!busy" type="button" mdbBtn color="trakly-action" block="true" class="my-4" type="submit">Save</button>
      </div>
    </form>
    <!-- Form -->
  </mdb-card-body>

  <mdb-card-body class="d-sm-flex justify-content-between" #Activity *ngIf="currentSection == 'Activity'">
    <!-- Form -->
    <form class="text-center border border-light p-5 w-100" (ngSubmit)="saveClicked()">
      <h4 class="font-weight-bold mb-4 text-left">Activity</h4>
      <hr />
      <!--Error Display-->
      <div *ngIf="!busy">
        <div class="col">
          <div *ngIf="showError" class="alert alert-danger" role="alert">
            {{ errorMsg }}
          </div>
        </div>
        ...
      </div>
      <!--Loading-->
      <div class="col-12 text-center">
        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <!--Save btn-->
      <div class="justify-content-left" id="settingsSaveBtn" style="width: 100px">
        <button *ngIf="!busy" type="button" mdbBtn color="trakly-action" block="true" class="my-4" type="submit">Save</button>
      </div>
    </form>
    <!-- Form -->
  </mdb-card-body>

  <mdb-card-body class="d-sm-flex justify-content-between" #Privacy *ngIf="currentSection == 'Privacy'">
    <!-- Form -->
    <form class="text-center border border-light p-5 w-100" (ngSubmit)="saveClicked()">
      <h4 class="font-weight-bold mb-4 text-left">Privacy</h4>
      <hr />
      <!--Error Display-->
      <div *ngIf="!busy">
        <div class="col">
          <div *ngIf="showError" class="alert alert-danger" role="alert">
            {{ errorMsg }}
          </div>
        </div>
        ...
      </div>
      <!--Loading-->
      <div class="col-12 text-center">
        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <!--Save btn-->
      <div class="justify-content-left" id="settingsSaveBtn" style="width: 100px">
        <button *ngIf="!busy" type="button" mdbBtn color="trakly-action" block="true" class="my-4" type="submit">Save</button>
      </div>
    </form>
    <!-- Form -->
  </mdb-card-body>

  <mdb-card-body class="d-sm-flex justify-content-between" #PaymentMethods *ngIf="currentSection == 'PaymentMethods'">
    <!-- Form -->
    <form class="text-center border border-light p-5 w-100" (ngSubmit)="saveClicked()">
      <h4 class="font-weight-bold mb-4 text-left">Payment methods</h4>
      <hr />
      <!--Error Display-->
      <div *ngIf="!busy">
        <div class="col">
          <div *ngIf="showError" class="alert alert-danger" role="alert">
            {{ errorMsg }}
          </div>
        </div>
        ...
      </div>
      <!--Loading-->
      <div class="col-12 text-center">
        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <!--Save btn-->
      <div class="justify-content-left" id="settingsSaveBtn" style="width: 100px">
        <button *ngIf="!busy" type="button" mdbBtn color="trakly-action" block="true" class="my-4" type="submit">Save</button>
      </div>
    </form>
    <!-- Form -->
  </mdb-card-body>
</mdb-card>

<div
  mdbModal
  #avatarModal="mdbModal"
  style="overflow-y: auto"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="avatarModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">Change Avatar</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!busy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="showError" class="alert alert-danger" role="alert">
              {{ errorMsg }}
            </div>
          </div>
          <!--Main Body-->
          <div>
            <div class="row">
              <div [ngClass]="{ view: avatarId.id == userProfile.avatarId }" class="col-3 my-3" *ngFor="let avatarId of avatarImageIds">
                <div class="avatar text-center mb-md-0 mb-4 mx-4 mt-3" style="cursor: pointer">
                  <img
                    src="../../../assets/img/profilePictures/{{ avatarId.id }}.png"
                    class="rounded-circle z-depth-1-half d-inline"
                    alt="Avatar"
                    style="max-width: 100px"
                    (click)="avatarSelected(avatarId.id)"
                  />
                  <div
                    *ngIf="avatarId.id == userProfile.avatarId"
                    class="mask flex-center waves-effect waves-light rgba-stylish-slight"
                  ></div>
                </div>
                <h6 class="text-center mt-2">Avatar {{ avatarId.id }}</h6>
              </div>
            </div>
          </div>
        </div>
        <!--Loading-->
        <div class="col-12 text-center">
          <div *ngIf="busy" class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <!--Save btn-->
      <div class="modal-footer justify-content-right">
        <button *ngIf="!busy" type="button" mdbBtn color="trakly-action" class="relative waves-light" (click)="saveClicked()">Save</button>
      </div>
    </div>
  </div>
</div>

<div
  mdbModal
  #newSupportingDocsModal="mdbModal"
  class="modal fade right"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myBasicModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="newSupportingDocsModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">New FIA Supporting Documents</h4>
      </div>
      <div class="modal-body">
        <div *ngIf="!modalBusy">
          <!--Error Display-->
          <div class="col">
            <div *ngIf="showModalError" class="alert alert-danger text-center font-weight-bold" role="alert">
              {{ errorModalMsg }}
            </div>
          </div>
          <!--Main Body-->
          <div class="d-block col-12" *ngIf="userNewDocuments?.length > 0">
            <p class="font-weight-bold mb-1">New Documents</p>
          </div>
          <table class="col-12" mdbTable *ngIf="userNewDocuments?.length > 0" hover="true" small="true" responsive="true">
            <thead>
              <tr>
                <th scope="col" class="col-4">File Name</th>
                <th scope="col" class="col-6">Type *</th>
                <th scope="col" class="col-2"></th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let docs of userNewDocuments">
                <td class="align-middle">{{ docs.fileName }}</td>
                <td class="align-middle">
                  <select
                    class="form-control"
                    [(ngModel)]="docs.fileType"
                    required
                    placeholder="Select document type"
                    style="display: block !important"
                  >
                    <option [ngValue]="''" disabled>Select type</option>
                    <option ngValue="Statement of Assets And Liabilities">Statement of Assets And Liabilities</option>
                    <option ngValue="Loan Agreement">Loan</option>
                    <option ngValue="Proof Of Source">Savings/Cash</option>
                    <option ngValue="Other">Other</option>
                  </select>
                </td>
                <td class="align-middle">
                  <a class="border dropdown-item text-center my-1" size="sm" (click)="removeFile(docs.fileName)" mdbWavesEffect>Remove</a>
                </td>
              </tr>
            </tbody>
          </table>
          <div *ngIf="userNewDocuments?.length == 0" class="alert alert-info text-center font-weight-bold" role="alert">
            No documents selected
          </div>
        </div>
        <!--Loading-->
        <div *ngIf="modalBusy" class="col-12 text-center">
          <div class="spinner-grow text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <!--Save btn-->
      <div class="modal-footer justify-content-right">
        <button
          *ngIf="!modalBusy && userNewDocuments?.length > 0"
          type="button"
          mdbBtn
          color="trakly-action"
          class="relative waves-light"
          (click)="newSupportingDocumentsModalSaveClicked()"
          [disabled]="missingDocumentTypes()"
        >
          Save
        </button>
        <button *ngIf="!modalBusy" type="button" mdbBtn color="trakly" class="relative waves-light" (click)="newSupportingDocsModal.hide()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div
  mdbModal
  #confirmDeleteModal="mdbModal"
  class="modal fade top"
  id="confirmDeleteModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="confirmDeleteModal"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm modal-notify modal-danger" role="document">
    <!--Content-->
    <div class="modal-content text-center">
      <!--Header-->
      <div class="modal-header d-flex justify-content-center">
        <p class="heading">Are you sure you would like to delete this document?</p>
      </div>
      <!--Body-->
      <div class="modal-body">
        <mdb-icon fas icon="times" size="4x" class="animated rotateIn"></mdb-icon>
      </div>
      <!--Footer-->
      <div class="modal-footer justify-content-center">
        <a mdbBtn color="danger" outline="true" class="waves-effect" (click)="confirmDeleteModalYesClicked()" mdbWavesEffect>Yes</a>
        <a type="button" mdbBtn color="danger" class="waves-effect" mdbWavesEffect data-dismiss="modal" (click)="cancelDelete()">No</a>
      </div>
    </div>
    <!--/.Content-->
  </div>
</div>
